import { css } from '@emotion/react'
import { size } from '@twistopayments/design-system/styles'

export const text = css`
  margin-bottom: ${size[16]};
`
